import {ActiveClosingsPage} from './ActiveClosingsPage'
import {ActiveClosingsPageNew} from './ActiveClosingsPageNew'
import {useOrganization} from '../OrganizationProvider'

export function ActiveClosingsPageToggle({...props}: {
  drawerHeight: number
}) {
  const org = useOrganization()
  const localStorageFlag = localStorage.getItem('UseNewOrderList') === 'true'
  const orgHasFeatureOn = !!org.UseNewOrderList

  return (localStorageFlag || orgHasFeatureOn)
    ? <ActiveClosingsPageNew {...props} />
    : <ActiveClosingsPage {...props} />
}